import PlantingOperationForm from "@/components/field/operations/PlantingOperationForm";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@heroui/react";
import { createFileRoute, Link, useParams } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute(
    "/dashboard/fields/$fieldId/operations/planting/$plantingOperationId",
)({
    component: RouteComponent,
});

function RouteComponent() {
    const { t } = useTranslation("operations");
    const { fieldId, plantingOperationId } = useParams({
        from: "/dashboard/fields/$fieldId/operations/planting/$plantingOperationId",
    });
    return (
        <div className="p-2">
            <Button
                size="sm"
                color="primary"
                as={Link}
                to="/dashboard/fields/$fieldId/operations"
                className="mb-2"
                params={
                    {
                        fieldId,
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } as any
                }
            >
                <FontAwesomeIcon icon={faChevronLeft} /> {t("backToOperations")}
            </Button>
            <PlantingOperationForm
                existingPlantingOperationId={Number(plantingOperationId)}
            />
        </div>
    );
}
